export enum BrandConfigSourceType {
    INIT = 'INIT',
    LOCAL = 'LOCAL',
    CACHE = 'CACHE',
    BSS = 'BSS',
    BSS_FALLBACK = 'BSS_FALLBACK',
}
export interface BrandConfig {
    source: BrandConfigSourceType;
    brandId: string;
    displayName: string;
    productName: string;
    shortDisplayName: string;
    notificationAppPrefixName: string;
    legalInfoPage: string;
    termsOfServicePage: string;
    privacyPolicyPage: string;
    trustCenterPage: string;
    supportRootPage: string;
    privacyControlsHelpPage: string;
    breakoutRoomsHelpPageLink?: string;
    launchYear: string;
    copyright: string;
    notificationTradeMark: string;
    downloadLink: {
        android: string;
        ios: string;
    };
    knowledgeBase: {
        systemRequirementsLink: string;
        chromaKeyLink: string;
        hardwareAccelerationLink: string;
        thirdPartyCameraLink: string;
    };
    assets: {
        mainLogoUrl: string;
        faviconUrl: string;
        blackLogoUrl: string;
        topPanelLogoUrl: string;
        watermarkUrl: string;
        poweredByLogoUrl: string;
        videoAboutIcon: string;
        topPanelColor: string;
        settingColor: string;
        settingActiveColor: string;
        settingActiveBgColor: string;
    };
}
export interface BssServerInfo {
    baseUri?: string;
    assetId?: string;
}
